import dateFormatter from './dateFormatter';

export default function yearDate(date: any, timeZone: any) {
  return dateFormatter(date, 'yyyy', timeZone);
}
